// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "物业管理专业导论",
        "tec": "王海燕",
        "week": "6-13,15周",
        "add": "教学楼D座315文法"
      },
      {
        "sub": "物业管理专业导论",
        "tec": "穆林林",
        "week": "16-18周",
        "add": "教学楼D座315文法"
      }
    ],
    {
      "sub": "管理学",
      "tec": "孙敬延",
      "week": "6-13,15-18周",
      "add": "教学楼D座426经管"
    },
    {
      "sub": "军事理论",
      "tec": "王庆喜",
      "week": "6-9,11-13,15-16周",
      "add": "教学楼D座315文法"
    },
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "6-9周",
      "add": "教学楼C座113教务"
    },
    0
  ],
  "2": [
    0,
    [
      {
        "sub": "大学英语（一）",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26经管1-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26经管1-2",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26经管2-2",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "王星月",
      "week": "6-10周",
      "add": "教学楼D座315文法"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    0
  ],
  "3": [
    {
      "sub": "微积分（一）",
      "tec": "于智慧",
      "week": "6-17周",
      "add": "教学楼C座310教务"
    },
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "刘鑫",
        "week": "6,8,10,12,16周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "刘鑫",
        "week": "7,9,11,13,15,17周",
        "add": "实训楼C座101"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "管理学",
      "tec": "孙敬延",
      "week": "6-13,15-18周",
      "add": "教学楼D座315文法"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "教学楼D座326文法"
      },
      {
        "sub": "26经管1-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "26经管1-2",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "26经管2-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "教学楼A座122信息"
      }
    ],
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "人工智能与计算思维",
      "tec": "刘鑫",
      "week": "6,8,10,12,16周",
      "add": "教学楼D座320经管"
    },
    {
      "sub": "微积分（一）",
      "tec": "于智慧",
      "week": "6-17周",
      "add": "教学楼C座213教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
